import React, { useState, useEffect } from 'react';

const FacebookLoginButton = ({ onLoginSuccess }) => {
      const [sdkReady, setSdkReady] = useState(false); // Track if SDK is ready
      const [token, setToken] = useState(null);

      // Facebook SDK initialization logic directly in the component
      useEffect(() => {
            // Define window.fbAsyncInit BEFORE loading the SDK script
            if (!window.fbAsyncInit) {
                  window.fbAsyncInit = function () {
                        console.log("Initializing Facebook SDK...");
                        window.FB.init({
                              appId: '1573300706874966', // Replace with your Facebook App ID
                              autoLogAppEvents: true,
                              xfbml: true,
                              version: 'v20.0', // The correct version you're using
                        });
                  };
            }

            // Load the Facebook SDK script if it's not already present
            const loadFacebookSDK = () => {
                  if (document.getElementById('facebook-jssdk')) {
                        console.log("Facebook SDK script already exists.");
                        setSdkReady(true);
                        return;
                  }

                  console.log("Loading Facebook SDK script...");
                  const js = document.createElement('script');
                  js.id = 'facebook-jssdk';
                  js.src = 'https://connect.facebook.net/en_US/sdk.js';
                  js.async = true;
                  js.onload = () => {
                        console.log("Facebook SDK script loaded.");
                        setSdkReady(true); // Set SDK ready once the script is loaded
                  };
                  const fjs = document.getElementsByTagName('script')[0];
                  fjs.parentNode.insertBefore(js, fjs);
            };

            // Load the SDK
            loadFacebookSDK();
      }, []);

      const handleFacebookLogin = () => {
            if (!sdkReady) {
                  console.log('Facebook SDK not initialized.');
                  return;
            }

            console.log("Facebook SDK loaded, starting login...");

            window.FB.login((response) => {
                  console.log("Login response received.");
                  if (response.authResponse) {
                        const accessToken = response.authResponse.accessToken;
                        setToken(accessToken); // Save the token in state
                        if (onLoginSuccess) {
                              onLoginSuccess(accessToken); // Call the success handler passed as a prop
                        }
                  } else {
                        console.error('User cancelled login or did not fully authorize.');
                  }
            }, { scope: 'email, public_profile, user_posts' });
      };

      return (
            <div>
                  <button onClick={handleFacebookLogin}>Login with Facebook</button>
            </div>
      );
};

export default FacebookLoginButton;
